import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../i18n/LanguageContext';

const About = () => {
  const { t } = useLanguage()

  return (
    <>
      <Helmet>
        <title>{t('metaAboutTitle')}</title>
        <meta name="description" content={t('metaAboutDesc')} />
      </Helmet>

      {/* Hero */}
      <div className="about_hero">
        <img className="about_hero_image" src={require("../img/dreef.webp")} alt={t('altAboutPhoto')} />
        <div className="about_hero_overlay"></div>
        <div className="about_hero_content">
          <h1 className="about_hero_title">{t('aboutTitle')}</h1>
        </div>
      </div>

      {/* Content */}
      <div className="about_section">
        <div className="about_card">
          <h3 className="about_card_title">{t('aboutWebsite')}</h3>
          <div className="about_card_body">
            {t('aboutText').split('\n\n').map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        </div>

        <div className="about_card">
          <h3 className="about_card_title">{t('aboutLinks')}</h3>
          <div className="about_card_body about_links">
            <a href="mailto:info@parkinghaarlem.nl" target="_blank" rel="noopener noreferrer">
              <span className="about_link_icon">✉</span>
              {t('aboutContact')} — info@parkinghaarlem.nl
            </a>
            <a href="https://haarlem.nl/open-data" target="_blank" rel="noopener noreferrer">
              <span className="about_link_icon">🔗</span>
              {t('aboutMunicipality')}
            </a>
            <a href="https://data.haarlem.nl/geoserver/wfs?service=WFS&version=2.0&request=GetFeature&outputFormat=application/json&srsName=EPSG%3A28992&typeName=gemeentehaarlem:bezetting_parkeergarages" target="_blank" rel="noopener noreferrer">
              <span className="about_link_icon">📊</span>
              {t('aboutDataset')}
            </a>
            <a href="https://www.flaticon.com/free-icons/pin" target="_blank" rel="noopener noreferrer">
              <span className="about_link_icon">🎨</span>
              Pin icons — Freepik (Flaticon)
            </a>
            <a href="https://www.flaticon.com/free-icons/404-error" target="_blank" rel="noopener noreferrer">
              <span className="about_link_icon">🎨</span>
              404 icons — Smashicons (Flaticon)
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
export default About
